import { html } from "lit";
import { u } from "@converse/headless";

export default (video_id, url, hide_url) => {
    const { hostname } = u.getURL(url);
    return html`<figure><iframe style="border-radius:12px" src="https://player.vimeo.com/video/${video_id}" width="100%" height="315" frameborder="0" allowfullscreen="" allow="autoplay; fullscreen; picture-in-picture" loading="lazy"></iframe>${hide_url ? "" : html`<a target="_blank" rel="noopener" title="${url}" href="${url}">${hostname}</a>`}</figure>`;
};
